<template>
	<div class="comp-chat-custom" v-if="menuType == 1">
		<div class="comp-chat-custom-all" @click="customAllClick()" :class="{'comp-chat-custom-all-active': 0 == currentCustom.id}">
			<img src="../assets/img/all-custom.png" alt="">
			<p>全部</p>
		</div>
		<div class="comp-chat-custom-list">
			<div class="comp-chat-custom-wrap">
				<div class="comp-chat-custom-items">
					<div class="comp-chat-custom-item" v-for="custom in customs" :key="'custom_' + custom.id" :title="custom.wx_name" 
					@click="customClick(custom)"
					:class="{'comp-chat-custom-item-active': custom.id == currentCustom.id}">
						<img :src="custom.wx_photo | connectHost" alt="">
						<p>{{custom.wx_name}}</p>
						<p v-if="custom.mark != ''">{{custom.mark}}</p>
						<p class="comp-chat-custom-identity" :class="{'comp-chat-custom-online' : custom.is_online}">{{custom.identity}}</p>
						<span v-if="custom.no_read_total>0">{{custom.no_read_total | pass99}}</span>
					</div>
				</div>
			</div>
		</div>
	</div>
	<div class="comp-chat-custom comp-chat-custom-black" v-else>
		<div class="comp-chat-custom-all comp-chat-custom-all-black" @click="customAllClick()" :class="{'comp-chat-custom-all-black-active': 0 == currentCustom.id}">
			<img src="../assets/img/all-custom-e6-32.png" alt="">
			<p>全部</p>
		</div>
		<div class="comp-chat-custom-list">
			<div class="comp-chat-custom-wrap comp-chat-custom-wrap-black">
				<div class="comp-chat-custom-items">
					<div class="comp-chat-custom-item comp-chat-custom-item-black" v-for="custom in customs" :key="'custom_' + custom.id" :title="custom.wx_name" 
					@click="customClick(custom)"
					:class="{'comp-chat-custom-item-black-active': custom.id == currentCustom.id}">
						<img :src="custom.wx_photo | connectHost" alt="">
						<p>{{custom.wx_name}}</p>
						<p v-if="custom.mark != ''">{{custom.mark}}</p>
						<p class="comp-chat-custom-identity" :class="{'comp-chat-custom-online' : custom.is_online}">{{custom.identity}}</p>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import {getCustomList} from '../network/local/custom.js'
	import {mapState} from 'vuex'
	import {getRecentlyNoReadCount} from '../network/local/recently.js'
	
	export default {
	  name: 'ChatCustom',
	  data(){
		  return {
			  currentCustom:{
				  id: 0,
				  wx_name: "",
				  wx_photo: '',
				  open_id: '',
				  identity: '',
				  is_online: 0,
				  phone_id: ''
			  },
			  customList: []
		  }
	  },
	  props:{
		  menuType:{
			   type:String,
			   default: '1'
		  },
		  chooseFirst:{
			  type: Boolean,
			  default:false
		  },
		  showCount:{
			  type: Boolean,
			  default:false
		  },
		  wxid:{
			  type: Object,
			  default:function(){
				  return {
					  
				  }
			  }
		  }
	  },
	  components: {
			
	  },
	  methods:{
		  // 客服切换
		  customClick(value){
			  this.currentCustom = value
			  this.$emit('custom-call',this.currentCustom)
		  },
		  
		  // 点击全部客服
		  customAllClick(){
			  this.currentCustom = {
				  id: 0,
				  wx_name: "",
				  wx_photo: '',
				  open_id: '',
				  identity: '',
				  is_online: 0,
				  phone_id: ''
			  }
			  this.$emit('custom-call',this.currentCustom)
		  },
		  
		  // 获取客服列表的未读消息数
		  getCustomNoRead(nVal){
			  if(this.showCount){
				  let wxid = ''
				  if(nVal !== undefined && nVal.wxid !== undefined){
					  wxid = nVal.wxid
				  }
				  getRecentlyNoReadCount(wxid,data=>{
					  for (let i = 0; i < this.customList.length; i++) {
						  let readData = data[this.customList[i].open_id]
						  if(readData !== undefined){
							  this.customList[i].no_read_total = readData.no_read_total
						  }
					  }
				  })
			  }
		  }
	  },
	  created() {
		  // 获取客服列表
	  	getCustomList((data)=>{
			for (let i = 0; i < data.length; i++) {
				data[i].no_read_total = 0
				this.customList.push(data[i])
			}
			// 选择第一个客服
			if(this.chooseFirst && this.customList.length > 0){
				this.currentCustom = this.customList[0]
				this.$emit('custom-call',this.currentCustom)
			}
			// 向父级返回列表
			this.$emit('chat-custom-call',this.customList)
			// 获取未读消息数
			this.getCustomNoRead()
		})
		
	  },
	  computed:{
		  customs(){
			  let online = this.$store.state.customOnline
			  let customOnline = []
			  let customOutline = []
			  for(let i in online){
				   if(online[i] == 1){
					   customOnline.push(i)
				   }else{
					   customOutline.push(i)
				   }
			  }
			  let customItems = []
			  for (let i = 0; i < this.customList.length; i++) {
				let phone_id = this.customList[i].phone_id
			  	if(customOnline.indexOf(phone_id) !== -1){
					this.customList[i].is_online = 1
				}else if(customOutline.indexOf(phone_id) !== -1){
					this.customList[i].is_online = 0
				}
				let mark = (this.customList[i].mark == null || this.customList[i].mark == '') ? '' : this.customList[i].mark
				customItems.push({
					id:this.customList[i].id,
					wx_name:this.customList[i].wx_name,
					wx_photo:this.customList[i].wx_photo,
					identity:this.customList[i].identity,
					open_id:this.customList[i].open_id,
					is_online:this.customList[i].is_online,
					phone_id:this.customList[i].phone_id,
					mark:mark,
					no_read_total:this.customList[i].no_read_total
				})
			  }
			  return customItems
		  }
	  },
	  watch:{
		  wxid(nVal){
			  this.getCustomNoRead(nVal)
		  }
	  }
	}
</script>

<style>
	.comp-chat-custom{
		position: relative;
		width: 80px;
		height: 100%;
		overflow: hidden;
		background-color: #e0e0e0;
		color: #666666;
	}
	.comp-chat-custom-black{
		background-color: #27354a !important;
		color: #CCCCCC !important;
	}
	.comp-chat-custom .comp-chat-custom-all{
		position: absolute;
		top: 0;
		left: 0;
		width: 60px;
		height: 60px;
		padding: 0 10px;
		overflow: hidden;
		cursor: pointer;
	}
	.comp-chat-custom .comp-chat-custom-all:hover{
		background-color: #e0e0e0;
	}
	.comp-chat-custom .comp-chat-custom-all-active{
		background-color: #cccccc !important;
	}
	.comp-chat-custom .comp-chat-custom-all-black:hover{
		background-color: #3f5679 !important;
	}
	.comp-chat-custom .comp-chat-custom-all-black-active{
		background-color: #3f5679 !important;
	}
	.comp-chat-custom .comp-chat-custom-all img{
		margin-left: 15px;
		margin-top: 12px;
		width: 30px;
		height: auto;
		display: block;
	}
	.comp-chat-custom .comp-chat-custom-all-black img{
		margin-left: 18px !important;
		margin-top: 10px !important;
		width: 24px !important;
	}
	.comp-chat-custom .comp-chat-custom-all p{
		height: 20px;
		line-height: 20px;
		text-align: center;
	}
	.comp-chat-custom .comp-chat-custom-list{
		position: absolute;
		top: 60px;
		left: 0;
		bottom: 0;
		overflow: hidden;
	}
	.comp-chat-custom-list .comp-chat-custom-wrap{
		width: 80px;
		height: 100%;
		overflow-x: hidden;
		overflow-y: auto;
	}
	.comp-chat-custom-wrap::-webkit-scrollbar{
		width: 6px;
		height: auto;
	}
	.comp-chat-custom-wrap::-webkit-scrollbar-track{
	  border-radius: 3px;
	  background:#c8c8c8;
	}
	.comp-chat-custom-wrap::-webkit-scrollbar-thumb{
	 border-radius: 3px;
	 -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
	 background:#969696;
	 cursor: pointer;
	}
	.comp-chat-custom-wrap-black::-webkit-scrollbar-track{
	  background:#75b7df;
	}
	.comp-chat-custom-wrap-black::-webkit-scrollbar-thumb{
	 -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
	 background:#5b8fad;
	}
	.comp-chat-custom-wrap .comp-chat-custom-items{
		text-align: center;
		font-size: 12px;
	}
	.comp-chat-custom-items .comp-chat-custom-item{
		width: 60px;
		padding: 10px;
		overflow: hidden;
		cursor: pointer;
		position: relative;
	}
	.comp-chat-custom-items .comp-chat-custom-item:hover{
		background-color: #cccccc;
	}
	.comp-chat-custom-items .comp-chat-custom-item-active{
		background-color: #cccccc !important;
	}
	.comp-chat-custom-items .comp-chat-custom-item-black:hover{
		background-color: #3f5679 !important;
	}
	.comp-chat-custom-items .comp-chat-custom-item-black-active{
		background-color: #3f5679 !important;
	}
	.comp-chat-custom-item img{
		width: 50px;
		height: 50px;
		border-radius: 6px;
		margin-left: 5px;
		display: block;
		margin-bottom: 5px;
	}
	.comp-chat-custom-item p{
		height: 16px;
		line-height: 16px;
		overflow: hidden;
	}
	.comp-chat-custom-item span{
		position: absolute;
		top: 5px;
		right: 10px;
		padding: 0 3px;
		height: 16px;
		line-height: 16px;
		border-radius: 50%;
		text-align: center;
		background-color: #f14b13;
		color: #FFFFFF;
		font-size: 12px;
		min-width: 10px;
	}
	.comp-chat-custom-item .comp-chat-custom-identity{
		color: #c50101;
		border-radius: 2px;
		font-weight: bold;
	}
	.comp-chat-custom-item .comp-chat-custom-online{
		color: #43a076 !important;
	}
</style>
